export default "__VITE_ASSET__BFIGhV2I__"